/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Hungarian
export default {
  'embedded-confluence-common.src.content.empty-state-description':
    'Megpróbáltuk megkeresni, de nincs ilyen oldal. Lehet, hogy törölték. Az is lehet, hogy csak elírtad az URL-t 😉',
  'embedded-confluence-common.src.content.empty-state-header': 'Nem találtuk meg, amit keresel',
  'embedded.confluence.already-logged-in-paragraph': 'Már bejelentkeztél? Próbálj meg frissíteni.',
  'embedded.confluence.footer.hover.text': 'Megtekintés a Confluence-ben',
  'embedded.confluence.footer.prefix': 'Szolgáltató:',
  'embedded.confluence.generic-error-page.login-to-confluence-button': 'Bejelentkezés a Confluence-be',
  'embedded.confluence.login-page.login-button': 'Bejelentkezés a Confluence-be',
  'embedded.confluence.login-page.login-button.aria-label': 'Bejelentkezés gomb',
  'embedded.confluence.login-page.login-text': 'Az oldal megtekintéséhez be kell jelentkezned',
  'embedded.confluence.login-page.refresh-page-banner':
    'Bejelentkezés után az oldal automatikusan frissül. Ha nem, kattints ide a frissítéshez.',
  'embedded.confluence.login-page.refresh-page-banner-refresh-link': 'Oldal frissítése',
  'embedded.confluence.need-to-log-in-paragraph': 'Az oldal megtekintéséhez be kell jelentkezned',
  'embedded.confluence.still-having-trouble-paragraph':
    'Még mindig problémába ütközöl? Győződj meg róla, hogy engedélyezted a harmadik felektől származó sütiket, vagy {link}',
  'embedded.confluence.troubleshooting-link-text': 'olvasd el ezt a hibaelhárítási útmutatót.',
  'embedded.confluence.troubleshooting-link.aria-label': 'hibaelhárítási útmutató linkje',
};
